<template>
  <a
    :class="[extraClasses, disabledClasses]"
    class="sf-btn"
    data-walkthrough-id="new-remark-button"
    @click="openModal"
    >{{ I18n.t('communication.add_remark') }}</a
  >
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '../../composables/use-I18n'
import useOpenRemarkModal from '../../composables/use-open-remark-modal'
import { isCurrentWorkflowLocked } from '@app/adapters/silverfin'

defineOptions({
  name: 'NewRemarkButton',
})

interface Props {
  ownerType?: string
  ownerId?: string | number
  ledgerId?: string | number
  ledgerLabel?: string
  extraClasses?: string
  hidePeriodSelector?: boolean
  selectedTagIds?: number[]
}

const props = defineProps<Props>()

const I18n = useI18n()

const disabled = isCurrentWorkflowLocked()

const disabledClasses = disabled ? ['sf-btn-disabled'] : []

const selectedTagIds = computed(() => props.selectedTagIds ?? [])

const openModal = useOpenRemarkModal({
  ownerType: props.ownerType,
  ownerId: props.ownerId,
  ledgerId: props.ledgerId,
  ledgerLabel: props.ledgerLabel,
  hidePeriodSelector: props.hidePeriodSelector,
  selectedTagIds: selectedTagIds,
})
</script>
